module.exports = __webpack_public_path__ + "static/media/lajifenlei.3e49420f.png";